import {
  CButton,
  CCard,
  CCardBody,
  CCol,
  CModal,
  CModalBody,
  CModalFooter,
  CModalHeader,
  CModalTitle,
  CRow,
} from "@coreui/react";
import { useCallback, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { constants } from "src/constant/constants";

const ShowHorseDetailsModal = ({ modalState, setModalState, modalData, isOwnerSearchPage = false }) => {
  const isAdmin = useSelector((state) => state.auth.isAdmin);
  const onModalShow = useCallback(() => { }, []);
  const onModalClose = useCallback(() => {
    setModalState(false);
  }, []);

  const [Sire, setSire] = useState(true);

  const [reversedAccolades, setReversedAccolades] = useState([]);

  useEffect(() => {
    if (modalData?.accolades && modalData.accolades?.length > 0) {
      setReversedAccolades([...modalData.accolades].reverse()); 
    }
  }, [modalData.accolades]);

  return (
    <CModal
      visible={modalState}
      size="lg"
      unmountOnClose
      onShow={onModalShow}
      onClose={onModalClose}
    >
      <CModalBody>
        <CModalHeader onClose={() => setModalState(false)}>
          <CModalTitle>Horse Details</CModalTitle>
        </CModalHeader>
        <CCol>
          <CCard className="mb-3 mt-3">
            <CCardBody>
              <CRow>
                <CCol sm={5}>
                  <h6 className="mb-0">Horse Name</h6>
                </CCol>
                <CCol sm={6} className="text-secondary">
                  {modalData.name ? modalData.name : "-"}
                </CCol>
              </CRow>
              <hr />
              <CRow>
                <CCol sm={5}>
                  <h6 className="mb-0">Owner Name</h6>
                </CCol>
                <CCol sm={6} className="text-secondary">
                  {modalData.ownerName ? modalData.ownerName : "-"}
                </CCol>
              </CRow>
              <hr />
              <CRow>
                <CCol sm={5}>
                  <h6 className="mb-0">ISHA Registration Number</h6>
                </CCol>
                <CCol sm={6} className="text-secondary">
                  {modalData.registrationNum ? modalData.registrationNum : "-"}
                </CCol>
              </CRow>
              <hr />
              <CRow>
                <CCol sm={5}>
                  <h6 className="mb-0">Other Registries</h6>
                </CCol>
                {modalData.otherRegistries && modalData.otherRegistries.length > 0 ? (
                  <>
                    <CCol sm={7}>
                      {modalData.otherRegistries.map((registry, index) => (
                        <>
                          <div key={index}>
                            <CRow className="mb-2">
                              <CCol sm={12}>
                                <div className="text-secondary">
                                  <span className="me-2">{registry.registryName}:</span>
                                  <span>{registry.registryNumber}</span>
                                </div>
                              </CCol>
                            </CRow>
                          </div>
                        </>

                      ))}
                    </CCol>
                  </>
                ) : (
                  <CCol sm={2}>
                    <CRow>
                      <CCol className="text-secondary">
                        --
                      </CCol>
                    </CRow>
                  </CCol>
                )}
              </CRow>
              <hr />
              <CRow>
                <CCol sm={5}>
                  <h6 className="mb-0">Sex</h6>
                </CCol>
                <CCol sm={6} className="text-secondary">
                  {modalData.sex ? modalData.sex : "-"}
                </CCol>
              </CRow>
              <hr />
              <CRow>
                <CCol sm={5}>
                  <h6 className="mb-0">Color</h6>
                </CCol>
                <CCol sm={6} className="text-secondary">
                  {modalData.color ? modalData.color : "-"}
                </CCol>
              </CRow>
              <hr />
              <CRow>
                <CCol sm={5}>
                  <h6 className="mb-0">Bred By</h6>
                </CCol>
                <CCol sm={6} className="text-secondary">
                  {modalData.bredBy ? modalData.bredBy : "-"}
                </CCol>
              </CRow>
              <hr />
              <CRow>
                <CCol sm={5}>
                  <h6 className="mb-0">DNA</h6>
                </CCol>
                <CCol sm={6} className="text-secondary">
                  {modalData.DNA ? modalData.DNA : "-"}
                </CCol>
              </CRow>
              <hr />
              <CRow>
                <CCol sm={5}>
                  <h6 className="mb-0">DNA CASE</h6>
                </CCol>
                <CCol sm={6} className="text-secondary">
                  {modalData.DNA_CASE ? modalData.DNA_CASE : "-"}
                </CCol>
              </CRow>
              <hr />
              <CRow>
                <CCol sm={5}>
                  <h6 className="mb-0">DNA Test Date</h6>
                </CCol>
                <CCol sm={6} className="text-secondary">
                  {modalData.DNA_TEST_DATE
                    ? modalData.DNA_TEST_DATE.substring(0, 10)
                    : "-"}
                </CCol>
              </CRow>
              <hr />
              <CRow>
                <CCol sm={5}>
                  <h6 className="mb-0">Foal Date</h6>
                </CCol>
                <CCol sm={6} className="text-secondary">
                  {modalData.foalDate
                    ? modalData.foalDate.substring(0, 10)
                    : "-"}
                </CCol>
              </CRow>
              <hr />
              <CRow>
                <CCol sm={5}>
                  <h6 className="mb-0">Markings</h6>
                </CCol>
                <CCol sm={6} className="text-secondary">
                  {modalData.markings ? modalData.markings : "-"}
                </CCol>
              </CRow>
              <hr />
              <CRow>
                <CCol sm={5}>
                  <h6 className="mb-0">Pedigree</h6>
                </CCol>
                <CCol sm={6} className="text-secondary">
                  {modalData.pedigree ? modalData.pedigree : "-"}
                </CCol>
              </CRow>
              <hr />
              <CRow>
                <CCol sm={5}>
                  <h6 className="mb-0">Verified</h6>
                </CCol>
                <CCol sm={6} className="text-secondary">
                  {modalData.verified ? "Yes" : "No"}
                </CCol>
              </CRow>
              <hr />
              <CRow>
                <CCol sm={5}>
                  <h6 className="mb-0">Accolades</h6>
                </CCol>
                {modalData.accolades && modalData.accolades.length > 0 ? (
                  <>
                    <CCol sm={7}>
                      {modalData.accolades.map((accolade, index) => (
                        <CRow key={index}>
                          <CCol className="text-secondary">
                            {accolade}
                          </CCol>
                        </CRow>
                      ))}
                    </CCol>
                  </>
                ) : (
                  <CCol sm={2}>
                    <CRow>
                      <CCol className="text-secondary">
                        --
                      </CCol>
                    </CRow>
                  </CCol>
                )}
              </CRow>
              <hr />

              <CRow className="mb-3">
                <CCol>
                  <button
                    onClick={(e) => {
                      // e.preventDefault();
                      setSire(true); // Set Sire to true when Sire button is clicked
                    }}
                    style={{
                      width: '100%',
                      background: Sire ? "#768192" : "transparent",
                      border: 'none',
                      boxShadow: '0 1px 4px 1px rgba(0, 0, 0, .4)',
                      padding: '9px',
                      color: Sire ? '#fff' : '#000',
                      fontWeight: 500
                    }}
                  >
                    Sire
                  </button>
                </CCol>
                <CCol>
                  <button
                    onClick={(e) => {
                      // e.preventDefault();
                      setSire(false); // Set Sire to false when Dam button is clicked
                    }}
                    style={{
                      width: '100%',
                      background: !Sire ? "#768192" : "transparent",
                      border: 'none',
                      boxShadow: '0 1px 4px 1px rgba(0, 0, 0, .4)',
                      padding: '9px',
                      color: !Sire ? '#fff' : '#000',
                      fontWeight: 500
                    }}
                  >
                    Dam
                  </button>
                </CCol>
              </CRow>

              <hr />
              {
                Sire &&
                <>
                  <CRow>
                    <CCol sm={5}>
                      <h6 className="mb-0">Sire Name</h6>
                    </CCol>
                    <CCol sm={6} className="text-secondary">
                      {modalData?.sire?.name ? modalData?.sire?.name : "-"}
                    </CCol>
                  </CRow>
                  <hr />
                  <CRow>
                    <CCol sm={5}>
                      <h6 className="mb-0">Grand Dam(Sire) Name</h6>
                    </CCol>
                    <CCol sm={6} className="text-secondary">
                      {modalData.sire?.grand_dam?.name ? modalData.sire?.grand_dam?.name : "-"}
                    </CCol>
                  </CRow>
                  <hr />
                  <CRow>
                    <CCol sm={5}>
                      <h6 className="mb-0">Grand Sire(Sire) Name</h6>
                    </CCol>
                    <CCol sm={6} className="text-secondary">
                      {modalData.sire?.grand_sire?.name ? modalData.sire?.grand_sire?.name : "-"}
                    </CCol>
                  </CRow>
                  <hr />
                  <CRow>
                    <CCol sm={5}>
                      <h6 className="mb-0">Great Grand Dam(Sire) Name
                      </h6>
                    </CCol>
                    <CCol sm={6} className="text-secondary">
                      {modalData.sire?.great_grand_dam?.name ? modalData.sire?.great_grand_dam?.name : "-"}
                    </CCol>
                  </CRow>
                  <hr />
                  <CRow>
                    <CCol sm={5}>
                      <h6 className="mb-0">Great Grand Sire(Sire) Name</h6>
                    </CCol>
                    <CCol sm={6} className="text-secondary">
                      {modalData.sire?.great_grand_sire?.name ? modalData.sire?.great_grand_sire?.name : "-"}
                    </CCol>
                  </CRow>
                  <hr />
                </>

              }
              {
                !Sire &&
                <>
                  <CRow>
                    <CCol sm={5}>
                      <h6 className="mb-0">Dam Name</h6>
                    </CCol>
                    <CCol sm={6} className="text-secondary">
                      {modalData?.dam?.name ? modalData?.dam?.name : "-"}
                    </CCol>
                  </CRow>
                  <hr />
                  <CRow>
                    <CCol sm={5}>
                      <h6 className="mb-0">Grand Dam(Dam) Name</h6>
                    </CCol>
                    <CCol sm={6} className="text-secondary">
                      {modalData.dam?.grand_dam?.name ? modalData.dam?.grand_dam?.name : "-"}
                    </CCol>
                  </CRow>
                  <hr />
                  <CRow>
                    <CCol sm={5}>
                      <h6 className="mb-0">Grand Sire(Dam) Name</h6>
                    </CCol>
                    <CCol sm={6} className="text-secondary">
                      {modalData.dam?.grand_sire?.name ? modalData.dam?.grand_sire?.name : "-"}
                    </CCol>
                  </CRow>
                  <hr />
                  <CRow>
                    <CCol sm={5}>
                      <h6 className="mb-0">Great Grand Dam(Dam) Name
                      </h6>
                    </CCol>
                    <CCol sm={6} className="text-secondary">
                      {modalData.dam?.great_grand_dam?.name ? modalData.dam?.great_grand_dam?.name : "-"}
                    </CCol>
                  </CRow>
                  <hr />
                  <CRow>
                    <CCol sm={5}>
                      <h6 className="mb-0">Great Grand Sire(Dam) Name</h6>
                    </CCol>
                    <CCol sm={6} className="text-secondary">
                      {modalData.dam?.great_grand_sire?.name ? modalData.dam?.great_grand_sire?.name : "-"}
                    </CCol>
                  </CRow>
                  <hr />
                </>
              }


              {/* {!isOwnerSearchPage  && (
                <>
                  <hr />
                  <CRow>
                    <CCol sm={5}>
                      <h6 className="mb-0">Registration Document</h6>
                    </CCol>
                    <CCol sm={6} className="text-secondary">
                      <CButton
                        color="primary"
                        href={
                          constants.downloadBaseUrl +
                          modalData.registrationDocument
                        }
                        target="_blank"
                        rel="noopener noreferrer"
                        download
                      >
                        Download
                      </CButton>
                    </CCol>
                  </CRow>

                  <hr />
                  <CRow>
                    <CCol sm={5}>
                      <h6 className="mb-0">DNA Kit document</h6>
                    </CCol>
                    <CCol sm={6} className="text-secondary">
                      <CButton
                        color="primary"
                        href={
                          constants.downloadBaseUrl + modalData.dnaKitDocument
                        }
                        target="blank"
                        rel="noopener noreferrer"
                        download
                      >
                        Download
                      </CButton>
                    </CCol>
                  </CRow>
                </>
              )} */}
            </CCardBody>
          </CCard>
        </CCol>
      </CModalBody>

      <CModalFooter>
        <CButton color="secondary" onClick={() => setModalState(false)}>
          Close
        </CButton>
      </CModalFooter>
    </CModal>
  );
};

export default ShowHorseDetailsModal;
